import { FormFieldSkeleton } from "@components/Atoms/FormSkeleton";
import { DialogBody } from "@ui-kit/Dialog";
import { FormFooter, FormStack } from "@ui-kit/Form";
import { Skeleton } from "@ui-kit/Skeleton";

const FIELDS = ["title", "description", "url", "search-phrases", "aliases"];

const PropsEditorSkeleton = () => (
	<div className="contents" data-qa="loading">
		<DialogBody>
			<FormStack>
				{FIELDS.map((field) => (
					<FormFieldSkeleton key={field} variant="vertical" />
				))}
			</FormStack>
		</DialogBody>
		<FormFooter primaryButton={<Skeleton className="h-10 w-24" />} />
	</div>
);

export default PropsEditorSkeleton;
